/* Ashloé — sticky purchase bar controller for sections/main-product.liquid.

   Replaces the previous malformed inline script, which contained a line of
   raw HTML inside a JavaScript function body and threw on parse, leaving
   the bar permanently hidden.

   This controller ONLY toggles a CSS class. It never reads, writes or
   rewrites form inputs, and it attaches no submit handlers, so the sticky
   form posts natively with the same variant and quantity the server
   rendered into it. */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-sticky-buy]');
    var anchor = document.querySelector('[data-main-buy-area]');
    if (!bar || !anchor) return;

    // Guard against double-initialisation if the script is included twice.
    if (bar.dataset.ashStickyReady === '1') return;
    bar.dataset.ashStickyReady = '1';

    function reveal(show) {
      bar.classList.toggle('is-visible', show);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show only once the primary Add to Cart has scrolled off the top.
          reveal(entry.boundingClientRect.bottom < 0);
        });
      }, { threshold: 0, rootMargin: '0px' });
      io.observe(anchor);
      return;
    }

    var ticking = false;
    function check() {
      ticking = false;
      reveal(anchor.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
    }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
